import { AuthenticationProvider, useAuthenticationContext } from './context'
import { FeatureFlowClassic } from './features/FlowClassic'
import { FeatureResetPassword } from './features/ResetPassword'
import { LogoutButton } from './LogoutButton'
import { useSession } from './session'

export const AuthenticationClient = {
  Flow: FeatureFlowClassic,
  Provider: AuthenticationProvider,
  use: useAuthenticationContext,
  useSession,
  LogoutButton,
  ResetPassword: FeatureResetPassword,
}
